
import React from "react";
import { Button } from "@/components/ui/button";

interface CityFilterProps {
  cityFilter: string | undefined;
  setCityFilter: (city: string | undefined) => void;
  cities: string[];
}

const CityFilter: React.FC<CityFilterProps> = ({
  cityFilter,
  setCityFilter,
  cities,
}) => {
  if (cities.length === 0) {
    return null;
  }

  return (
    <div>
      <h4 className="text-sm font-medium mb-3">City</h4>
      <div className="flex flex-wrap gap-2">
        <Button
          key="all-cities"
          variant={cityFilter === undefined ? "default" : "outline"}
          size="sm"
          onClick={() => setCityFilter(undefined)}
          className={cityFilter === undefined ? "bg-eco-500 hover:bg-eco-600" : ""}
        >
          All
        </Button>
        
        {cities.map((city) => (
          <Button
            key={city}
            variant={cityFilter === city ? "default" : "outline"}
            size="sm"
            onClick={() => setCityFilter(city)}
            className={cityFilter === city ? "bg-eco-500 hover:bg-eco-600" : ""}
          >
            {city}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default CityFilter;
